/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_History_WhoInputs */

const cs_lustrace_history_who = /** @type {(inputs: Lustrace_History_WhoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kdo`)
};

const en_lustrace_history_who = /** @type {(inputs: Lustrace_History_WhoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who`)
};

/**
* | output |
* | --- |
* | "Who" |
*
* @param {Lustrace_History_WhoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_history_who = /** @type {((inputs?: Lustrace_History_WhoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_History_WhoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_history_who(inputs)
	return cs_lustrace_history_who(inputs)
});